import { useQuery } from '@tanstack/react-query';
import { container } from '@infrastructure/container';
import { Marketplace } from '@domain/product/models/Marketplace';

export const useProductMarketplaces = () => {
  const { data: marketplacesResponse, isLoading, error } = useQuery<Marketplace[]>({
    queryKey: ['product-marketplaces'],
    queryFn: async () => {
      const result = await container.productRepository.getProductMarketplaces();
      if (result.status === 'error') throw new Error(result.error.message);
      return result.data;
    },
  });

  return {
    marketplaces: marketplacesResponse ?? [],
    isLoading,
    error,
  };
};
